import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import axios from "axios";
// import { ref, reactive, onMounted } from "vue";
// import { wexinShare } from "../src/utils/wxShare.js";
// onMounted(() => {
//   getData();
// });
// const getData = () => {
//   let url = location.href;
//   let obj = {
//     appid: "wxbc5b737d6921c2dd",
//     localUrl: url,
//   };
//   axios
//     .post("https://test.333f.com/data-center/wechat/sign", obj)
//     .then((res) => {
//       let wxUserInfo = res.data.data;
//       let obj = {
//         appId: wxUserInfo.appId,
//         nonceStr: wxUserInfo.nonceStr,
//         signature: wxUserInfo.signature,
//         timestamp: wxUserInfo.timestamp.toString(),
//         jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
//       };
//       wexinShare(obj);
//     })
//     .catch(() => {});
// };

import { defineComponent } from "vue";
import Home from "@/views/home.vue"; // @ is an alias to /src

const __default__ = defineComponent({
  name: "loginView",
  components: {
    Home,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Home))
}
}

})